export default "__VITE_ASSET__Waor8BiB__"